export default __webpack_public_path__ + "static/media/rp3-logo.57cd1c3d.svg";